import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = this.localSameOriginUrl(req.url);
    return next.handle(req.credentials === 'include' && url === req.url
      ? req
      : req.clone({ url, withCredentials: false, credentials: 'include' }));
  }

  private localSameOriginUrl(url: string): string {
    if (typeof window === 'undefined') {
      return url;
    }

    const gateway = environment.apiGatewayUrl.replace(/\/+$/, '');
    if (!gateway || !url.startsWith(`${gateway}/`)) {
      return url;
    }

    const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isPlatformAdminLocal = isLocalHost && window.location.port === '4600';
    const isLocalGateway = gateway === 'http://localhost:4000' || gateway === 'http://127.0.0.1:4000';
    if (!isPlatformAdminLocal || !isLocalGateway) {
      return url;
    }

    return url.slice(gateway.length);
  }
}
